__turbopack_context__.v({
  "container": "NewsletterBanner-module__kGW4kq__container",
  "image": "NewsletterBanner-module__kGW4kq__image",
});
